/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 9999eb1d882990f19e352fba26b6c3f62977c8a7
 */

export type Tier = typeof Tier[keyof typeof Tier];


export const Tier = {
  tier_1: 'tier_1',
  tier_2: 'tier_2',
  tier_3: 'tier_3',
} as const;
